import { Controller } from "stimulus";
import { ScrollSpy } from "bootstrap";

export default class NavController extends Controller {
  static targets = ['collapsible', 'logoMobile'];

  initialize() {
    console.log("Hello, Nav", this.element);

    document.addEventListener("scroll", (event) => {
      this.toggleNav(window.scrollY);
    }, false);

    new ScrollSpy(document.body, {
      target: '#navbar',
      offset: 65
    });
  }

  toggleNav(scrollY) {
    if(scrollY > 200) {
      this.element.classList.add('navbar-light');
      this.element.classList.remove('navbar-dark');
    } else {
      this.element.classList.add('navbar-dark');
      this.element.classList.remove('navbar-light');
    }
  }
}
